import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGarantieMaxActions, IGarantieMaxStepProps } from '../GarantieMax';
import { Row, Col } from 'react-bootstrap';
import leftArrowIconUrl from 'assets/bf-images/left-arrow.svg';
import { PaymentType } from 'Services/widgets/enums';
import { StripeSystem } from './payment-systems/StripeSystem';
import { AppAlertUI } from 'App/components/utils/alerts/AppAlertService';
import { GMBFStep } from 'App/components/widgets/garantie-max/enum';

export interface IPaymentDataStep {
  paymentMethod: string;
  accountFirstName?: string;
  accountLastName?: string;
  accountEmail?: string;
  paymentDataValid?: boolean;
}

export const PaymentStep: React.FC<IGarantieMaxStepProps> = ( { lead, productData } ) => {
  const { t } = useTranslation( [ 'widgets', 'base' ] );
  const actions = useGarantieMaxActions();

  const { leadData } = productData;

  if ( lead.subStep2TariffData === null ) {
    actions.goToSubStep( 'subStep2', false );
  }

  return (
    <Row className="mt-3" id="payment-data-step">
      <Col md={ 12 } className="sticky-top z-idx-auto">
        <button
          id={ `${GMBFStep.PaymentStep}_back` }
          type="button"
          className="btn btn-link m-0 p-0 text-c-black f-16 back-button"
          onClick={ () => actions.goToSubStep( 'subStep2', false ) }
        >
          <img src={ leftArrowIconUrl } alt="Back" />
          <span className="back-text pl-3 align-middle">
            { t( 'bookingFunnel.previousBtn' ) }
          </span>
        </button>
      </Col>
      <Row className="max-w-450">
        <Col md={ 12 } className="head-tab text-center px-0">
          <AppAlertUI />
        </Col>
        <Col md={ 12 } className="head-tab text-center px-0">
          <h1 className="f-26 text-c-black">{ t( 'bookingFunnel.paymentData.stepTitleGM' ) }</h1>
        </Col>
        <Col md={ 12 } className="bf-custom-px">
          { leadData.psp === PaymentType.Stripe && (
            <StripeSystem
              lead={ lead }
              productData={ productData }
            />
          ) }
        </Col>
      </Row>
    </Row>
  );
};
